// src/components/modals/DetailsModal/SentenceModalTabs/SentenceDetailsTab.js
import React from 'react';
import { LanguageIcon, ChatBubbleBottomCenterTextIcon } from '@heroicons/react/24/outline';
import GlassyIcon from '../../../common/GlassyIcon';

const SentenceDetailsTab = ({ sentence }) => (
  <div className="relative p-4 sm:p-6">
    {/* Background bubbles - left and right sides */}
    <div className="fixed inset-0 pointer-events-none" style={{ zIndex: -1 }}>
      <div className="relative w-full h-full overflow-hidden">
        {/* Right side bubbles */}
        <div
          className="absolute rounded-full backdrop-blur-sm border border-white/10"
          style={{
            background: 'linear-gradient(135deg, rgba(59, 130, 246, 0.15), rgba(139, 92, 246, 0.10))',
            width: '100px',
            height: '100px',
            top: '10%',
            right: '5%',
            boxShadow: '0 8px 32px rgba(59, 130, 246, 0.08)',
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-br from-white/15 to-transparent opacity-50 rounded-full" />
        </div>
        <div
          className="absolute rounded-full backdrop-blur-sm border border-white/10"
          style={{
            background: 'linear-gradient(45deg, rgba(236, 72, 153, 0.12), rgba(34, 197, 94, 0.08))',
            width: '70px',
            height: '70px',
            bottom: '15%',
            right: '8%',
            boxShadow: '0 8px 32px rgba(236, 72, 153, 0.06)',
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-br from-white/15 to-transparent opacity-50 rounded-full" />
        </div>

        {/* Left side bubbles */}
        <div
          className="absolute rounded-full backdrop-blur-sm border border-white/10"
          style={{
            background: 'linear-gradient(225deg, rgba(34, 197, 94, 0.12), rgba(59, 130, 246, 0.08))',
            width: '85px',
            height: '85px',
            top: '25%',
            left: '5%',
            boxShadow: '0 8px 32px rgba(34, 197, 94, 0.06)',
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-br from-white/15 to-transparent opacity-50 rounded-full" />
        </div>
        <div
          className="absolute rounded-full backdrop-blur-sm border border-white/10"
          style={{
            background: 'linear-gradient(315deg, rgba(139, 92, 246, 0.10), rgba(236, 72, 153, 0.08))',
            width: '65px',
            height: '65px',
            bottom: '20%',
            left: '8%',
            boxShadow: '0 8px 32px rgba(139, 92, 246, 0.05)',
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-br from-white/15 to-transparent opacity-50 rounded-full" />
        </div>
      </div>
    </div>

    {/* Content */}
    <div className="relative space-y-6 sm:space-y-8">
      {/* Translation Section */}
      <div>
        <div className="flex items-center mb-3 sm:mb-4">
          <GlassyIcon 
            icon={LanguageIcon} 
            size="sm"
            color="orange"
            className="mr-3"
          />
          <h3 className="text-base sm:text-lg font-bold text-content-primary">Translation</h3>
        </div>
        <div 
          className="
            text-lg sm:text-xl font-medium text-content-primary leading-relaxed
            p-3 sm:p-4 rounded-xl bg-background-secondary border border-border
            ml-2 sm:ml-6
          "
        >
          {sentence.translation}
        </div>
      </div>

      {/* Kana Section */}
      {sentence.sentence_kana && (
        <div>
          <div className="flex items-center mb-3 sm:mb-4">
            <GlassyIcon 
              icon={ChatBubbleBottomCenterTextIcon} 
              size="sm"
              color="blue"
              className="mr-3"
            />
            <h3 className="text-base sm:text-lg font-bold text-content-primary">Kana Reading</h3>
          </div>
          <div 
            className="
              text-lg sm:text-xl font-medium text-content-primary leading-relaxed
              p-3 sm:p-4 rounded-xl bg-background-secondary border border-border
              ml-2 sm:ml-6
            " 
            lang="ja"
          >
            {sentence.sentence_kana}
          </div>
        </div>
      )}
    </div>
  </div>
);

export default SentenceDetailsTab;